import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import DropZone from 'components/Shared/DropZone';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';

import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },
    formControl: {
        margin: 0
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

class RetourPhysiqueSansDossierStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece'
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        // On vérifie que la réclamation possède un enregistrement pour chaque détail.
        let nextStepValid = false;
        if (reclamation !== null) {
            if (reclamation.numeroPiece.length > 0) {
                nextStepValid = true;
            }
        }

        onNextStepValid(nextStepValid);
    }

    checkErrors() {
        const { reclamation } = this.props;

        let errors = [];

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        }
        else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        if (reclamation.lignes.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Saisie obligatoire sur au moins une ligne.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: null });
        }


        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece, onNextStepValid } = this.props;

        onNextStepValid(true);

        const errors = this.checkErrors();

        onSelectPiece(value, errors, true);

        // On ouvre le panel qui contient les lignes de la pièce.
        this.setState({
            expandedPanel: 'panelLignes'
        });
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        const errors = this.checkErrors();

        onChange(event, errors);
    }


    handleAddLigne = (ligne) => {
        const { onAddLigne } = this.props;

        const errors = this.checkErrors();

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne } = this.props;

        const errors = this.checkErrors();

        onRemoveLigne(numeroLigne, errors);
    }

    render() {
        const { classes, reclamation, namespace } = this.props;
        const { expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>


                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce*</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>


                    <Accordion expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Sélectionner une ligne* (au moins une ligne en anomalie pour pouvoir créer le dossier après-vente)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className={classes.row}>
                                <LigneGestionQualification
                                    reclamation={reclamation}
                                    onAddLigne={this.handleAddLigne}
                                    onRemoveLigne={this.handleRemoveLigne}
                                    typeAnomalie={AnomalieType.DemandeRetour}
                                />

                            </div>
                        </AccordionDetails>
                    </Accordion>

                </div>
            </React.Fragment>
        );
    }
}

RetourPhysiqueSansDossierStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(RetourPhysiqueSansDossierStep);